import Button from "@mui/material/Button";
import { useContext, useEffect, useState } from "react";
import { APIContext } from '../Contexts/APIContext';
import Paper from "@mui/material/Paper";
import { FormContainer } from "react-hook-form-mui";
import ValidatedSelectElement from "../Utilities/Forms/ValidatedSelectElement";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid2";
import DropDownViewModel from "../Utilities/ViewModels/DropDownViewModel";
import { TelemetryContext, extractTelemetryFileName } from "../Contexts/TelemetryContext";

interface IProps {
    folder: string;
}

export default function GoodPracticeGuide(props: IProps) {
    const { logFileAccess } = useContext(TelemetryContext);
    const { get } = useContext(APIContext);
    const [fileNames, setFileNames] = useState<DropDownViewModel[]>([]);
    const [defaultValue, setDefaultValue] = useState<string>();

    const extractYear = (option: DropDownViewModel): number => {
        const match = option.label.match(/\b(19|20)\d{2}\b/);
        return match ? Number(match[0]) : Number.MIN_SAFE_INTEGER;
    };

    useEffect(() => {
        get('Document', `GetTableFiles?folder=${props.folder}`,
            (files: DropDownViewModel[]) => {
                if (files.length === 0) return;

                const sortedFiles = [...files]
                    .map((file, index) => ({ file, index }))
                    .sort((a, b) => {
                        const yearDifference = extractYear(b.file) - extractYear(a.file);
                        if (yearDifference !== 0) return yearDifference;
                        return a.index - b.index;
                    })
                    .map((entry) => entry.file);

                setDefaultValue(sortedFiles[0].id);
                setFileNames(sortedFiles);
            }
        );
    }, []);

    const getFile = (form: any) => {
        logFileAccess(extractTelemetryFileName(form.url), "GoodPracticeGuide");
        window.open(form.url, "_blank");
    };

    return (
        <Paper>
            <Typography variant="h5">{props.folder === "NewSites" ? "New Sites" : "Good Practice Guide"}</Typography>
            <FormContainer key={defaultValue} defaultValues={{ url: defaultValue }} onSuccess={getFile}>
                <Grid container>
                    <Grid size={10}>
                        <ValidatedSelectElement name={"url"} options={fileNames} value={defaultValue} />
                    </Grid>
                    <Grid size={2}>
                        <Button type="submit">View</Button>
                    </Grid>
                </Grid>
            </FormContainer>
        </Paper>
    );
}
